import { createContext } from 'react';
import { getFeatureFlags, type FeatureFlags } from '@a1/shared';

// Default to all flags off so consumers outside the provider fail safely.
const FeatureFlagsContext = createContext<FeatureFlags>(getFeatureFlags(null));

export default FeatureFlagsContext;
